import '../../../../assets/css/screens/serviceprovider/dashboard/bookingg/WorkerBookingg.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Clock, CheckCircle, AlertCircle, CheckCheck,
  XCircle, MapPin, Calendar, User, Upload, X, Play,
  Image as ImgIcon, ShieldAlert, DollarSign, Star,
  MessageSquare, Send, Headphones
} from 'lucide-react';

const STATES = {
  worker_dispute:        { label:'My Dispute',       color:'#f97316', bg:'rgba(249,115,22,0.12)',  icon:<ShieldAlert size={12}/> },
  draft:                 { label:'Draft',            color:'#94a3b8', bg:'rgba(148,163,184,0.12)', icon:<Clock size={12}/> },
  open:                  { label:'Open',             color:'#0491e1', bg:'rgba(4,145,225,0.12)',   icon:<CheckCircle size={12}/> },
  assigned:              { label:'Assigned',         color:'#8b5cf6', bg:'rgba(139,92,246,0.12)',  icon:<AlertCircle size={12}/> },
  in_progress:           { label:'In Progress',      color:'#f59e0b', bg:'rgba(245,158,11,0.12)',  icon:<AlertCircle size={12}/> },
  awaiting_confirmation: { label:'Awaiting Confirm', color:'#06b6d4', bg:'rgba(6,182,212,0.12)',   icon:<Clock size={12}/> },
  completed:             { label:'Completed',        color:'#10b981', bg:'rgba(16,185,129,0.12)',  icon:<CheckCheck size={12}/> },
  dispute_frozen:        { label:'Dispute Frozen',   color:'#ef4444', bg:'rgba(239,68,68,0.12)',   icon:<ShieldAlert size={12}/> },
  cancelled:             { label:'Cancelled',        color:'#ef4444', bg:'rgba(239,68,68,0.12)',   icon:<XCircle size={12}/> },
  refunded:              { label:'Refunded',         color:'#10b981', bg:'rgba(16,185,129,0.12)',  icon:<DollarSign size={12}/> },
  admin_review:          { label:'Admin Review',     color:'#f59e0b', bg:'rgba(245,158,11,0.12)',  icon:<ShieldAlert size={12}/> },
};

const TABS = ['All','open','assigned','in_progress','awaiting_confirmation','worker_dispute','completed','cancelled'];

let _jobs = [
  { id:'j-1',  title:'AC Repair',             customer:'Ahmed Khan',   location:'Lahore',     date:'Apr 01, 2026', price:3500,  state:'open',
    customerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1631545804623-83852ba9c961?w=400&q=80'},{type:'image',url:'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80'}],
    proofMedia:[], note:'AC not cooling properly.', review:null, workerReply:'' },
  { id:'j-2',  title:'Roof Leakage Fix',      customer:'Tariq Rehman', location:'Lahore',     date:'Apr 01, 2026', price:2800,  state:'open',
    customerMedia:[], proofMedia:[], note:'Water dripping in bedroom.', review:null, workerReply:'' },
  { id:'j-3',  title:'Electrical Wiring',     customer:'Sara Malik',   location:'Karachi',    date:'Apr 02, 2026', price:5000,  state:'assigned',
    customerMedia:[{type:'video',url:'https://www.w3schools.com/html/mov_bbb.mp4',thumb:'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&q=80'}],
    proofMedia:[], note:'Full house rewiring needed.', review:null, workerReply:'' },
  { id:'j-4',  title:'Plumbing Installation', customer:'Bilal Ahmed',  location:'Faisalabad', date:'Apr 02, 2026', price:3200,  state:'assigned',
    customerMedia:[], proofMedia:[], note:'New bathroom fittings.', review:null, workerReply:'' },
  { id:'j-5',  title:'Wall Painting 2 Rooms', customer:'Usman Ali',    location:'Islamabad',  date:'Apr 03, 2026', price:12000, state:'in_progress',
    customerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&q=80'}],
    proofMedia:[], note:'', review:null, workerReply:'' },
  { id:'j-6',  title:'Kitchen Renovation',    customer:'Nadia Khan',   location:'Islamabad',  date:'Apr 03, 2026', price:18000, state:'in_progress',
    customerMedia:[], proofMedia:[], note:'Full kitchen cabinets.', review:null, workerReply:'' },
  { id:'j-7',  title:'Bathroom Tiles Work',   customer:'Hassan Ali',   location:'Multan',     date:'Apr 04, 2026', price:7500,  state:'awaiting_confirmation',
    customerMedia:[], proofMedia:[{type:'image',url:'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400&q=80'}],
    note:'', review:null, workerReply:'' },
  { id:'j-8',  title:'Roof Waterproofing',    customer:'Imran Butt',   location:'Karachi',    date:'Mar 28, 2026', price:9000,  state:'completed',
    customerMedia:[], proofMedia:[{type:'image',url:'https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?w=400&q=80'}],
    note:'', review:{ rating:5, text:'Excellent work, very neat and clean!' }, workerReply:'' },
  { id:'j-9',  title:'Furniture Repair',      customer:'Amna Tariq',   location:'Lahore',     date:'Mar 25, 2026', price:4500,  state:'completed',
    customerMedia:[], proofMedia:[], note:'', review:{ rating:4, text:'Good service, on time.' }, workerReply:'Thank you so much!' },
  { id:'j-10', title:'Carpet Cleaning',       customer:'Zara Sheikh',  location:'Islamabad',  date:'Mar 20, 2026', price:2000,  state:'cancelled',
    customerMedia:[], proofMedia:[], note:'', review:null, workerReply:'' },
  { id:'j-11', title:'Woodwork Cabinets',     customer:'Fahad Malik',  location:'Karachi',    date:'Mar 15, 2026', price:6000,  state:'worker_dispute',
    customerMedia:[], proofMedia:[], note:'', review:null, workerReply:'' },
];

export const getJobs = () => _jobs;
const updateJob = (id, patch) => { _jobs = _jobs.map(j => j.id === id ? { ...j, ...patch } : j); };

/* ══════════ PROOF MODAL ══════════ */
const ProofModal = ({ onClose, onSubmit }) => {
  const [files,   setFiles]   = useState([]);
  const [loading, setLoading] = useState(false);
  const handleFiles = e => {
    const picked = Array.from(e.target.files).map(f => ({
      url: URL.createObjectURL(f),
      type: f.type.startsWith('video') ? 'video' : 'image',
    }));
    setFiles(p => [...p, ...picked]);
  };
  const submit = () => {
    if (!files.length) return;
    setLoading(true);
    setTimeout(() => { setLoading(false); onSubmit(files); }, 1200);
  };
  return (
    <div className="aj-modal-overlay" onClick={onClose}>
      <div className="aj-modal" onClick={e => e.stopPropagation()}>
        <button className="aj-modal__close" onClick={onClose}><X size={18}/></button>
        <h3 className="aj-modal__title">Upload Proof of Work</h3>
        <p className="aj-modal__sub">Upload photo/video of completed work to mark job as done.</p>
        {files.length > 0 && (
          <div className="aj-proof-preview-row">
            {files.map((f, i) => (
              <div key={i} className="aj-media-thumb" style={{ position:'relative' }}>
                {f.type === 'video'
                  ? <video src={f.url} className="aj-media-thumb__img"/>
                  : <img src={f.url} alt="" className="aj-media-thumb__img"/>}
                <button className="aj-proof-thumb-del" onClick={() => setFiles(p => p.filter((_,x) => x !== i))}><X size={11}/></button>
              </div>
            ))}
          </div>
        )}
        <label className="aj-upload-area" style={{ cursor:'pointer' }}>
          <Upload size={22}/>
          <span>Tap to add photo / video</span>
          <span className="aj-upload-area__hint">JPG, PNG, MP4, MOV</span>
          <input type="file" accept="image/*,video/*" multiple style={{ display:'none' }} onChange={handleFiles}/>
        </label>
        <button
          className={'aj-modal__submit' + (loading ? ' aj-modal__submit--loading' : '')}
          disabled={!files.length || loading}
          onClick={submit}
        >
          {loading ? <><span className="aj-spinner"/> Uploading...</> : <><CheckCheck size={15}/> Mark as Completed</>}
        </button>
      </div>
    </div>
  );
};

/* ══════════ LIGHTBOX ══════════ */
const Lightbox = ({ item, onClose }) => {
  if (!item) return null;
  return (
    <div className="aj-lb" onClick={onClose}>
      <button className="aj-lb__close" onClick={onClose}><X size={20}/></button>
      <div className="aj-lb__content" onClick={e => e.stopPropagation()}>
        {item.type === 'video'
          ? <video src={item.url} controls autoPlay className="aj-lb__media"/>
          : <img src={item.url} alt="" className="aj-lb__media"/>}
      </div>
    </div>
  );
};

const Stars = ({ rating }) => (
  <div className="aj-stars">
    {[1,2,3,4,5].map(s => (
      <Star key={s} size={13} fill={s <= rating ? '#f59e0b' : '#e5e7eb'} color={s <= rating ? '#f59e0b' : '#e5e7eb'}/>
    ))}
  </div>
);

const AllJobs = () => {
  const navigate = useNavigate();
  const [jobs,      setJobs]     = useState(() => getJobs());
  const [activeTab, setActive]   = useState('All');
  const [proofFor,  setProofFor] = useState(null);
  const [lightbox,  setLightbox] = useState(null);
  const [replies,   setReplies]  = useState({});

  const refresh = () => setJobs([...getJobs()]);
  const move    = (id, s) => { updateJob(id, { state: s }); refresh(); };

  const handleAccept = id => move(id, 'assigned');
  const handleReject = id => move(id, 'cancelled');
  const handleStart  = id => move(id, 'in_progress');

  /* ── in_progress: Raise Dispute button
       1. State change → worker_dispute
       2. Redirect to /worker-support (new ticket, no specific ticket yet)         */
  const handleRaiseDispute = (job) => {
    updateJob(job.id, { state: 'worker_dispute' });
    refresh();
    navigate('/worker-support', {
      state: {
        jobId:       job.id,
        jobTitle:    job.title,
        fromDispute: true,
        openNew:     true,        // support page should open "New Ticket" form
      }
    });
  };

  /* ── worker_dispute: Headphones button in card top-right
       Opens the existing dispute ticket chat for this specific job             */
  const openDisputeChat = (job) => {
    navigate('/worker-support', {
      state: {
        jobId:       job.id,
        jobTitle:    job.title,
        fromDispute: true,
        openTicket:  true,        // support page should open the existing ticket chat
      }
    });
  };

  const handleProof = (id, files) => {
    updateJob(id, { state: 'awaiting_confirmation', proofMedia: files });
    setProofFor(null);
    refresh();
  };

  const handleReply = (id) => {
    const text = (replies[id] || '').trim();
    if (!text) return;
    updateJob(id, { workerReply: text });
    setReplies(r => ({ ...r, [id]: '' }));
    refresh();
  };

  const filtered = jobs.filter(j => activeTab === 'All' ? true : j.state === activeTab);
  const cnt      = t => jobs.filter(j => j.state === t).length;

  return (
    <>
      <WorkerNavbar/>
      <div className="aj-page">
        <div className="aj-header">
          <button className="aj-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={22}/></button>
          <h2 className="aj-title">Bookings</h2>
        </div>

        {/* ── Tabs ── */}
        <div className="aj-tabs">
          {TABS.map(t => (
            <button key={t} className={'aj-tab' + (activeTab === t ? ' aj-tab--active' : '')} onClick={() => setActive(t)}>
              {t === 'All' ? 'All' : (STATES[t]?.label || t)}
              {t !== 'All' && cnt(t) > 0 && <span className="aj-tab__count">{cnt(t)}</span>}
            </button>
          ))}
        </div>

        {/* ── Job List ── */}
        <div className="aj-list">
          {filtered.length === 0 ? (
            <div className="aj-empty"><CheckCheck size={42}/><p>No jobs in this state</p></div>
          ) : filtered.map((job, i) => {
            const st = STATES[job.state] || STATES.open;
            return (
              <div key={job.id} className="aj-card" style={{ animationDelay: i * 0.06 + 's' }}>

                {/* ── Top row ── */}
                <div className="aj-card__top">
                  <div>
                    <h5 className="aj-card__title">{job.title}</h5>
                    <span className="aj-type-badge aj-type-badge--direct">📞 Direct Booking</span>
                  </div>
                  <div className="aj-card__top-right">
                    {/* Status badge */}
                    <span className="aj-badge" style={{ color: st.color, background: st.bg }}>
                      {st.icon} {st.label}
                    </span>

                    {/* ── worker_dispute: Headphones button — opens EXISTING ticket chat ── */}
                    {/* {job.state === 'worker_dispute' && (
                      <button
                        className="aj-btn-support-icon"
                        title="Open Dispute Chat"
                        onClick={() => openDisputeChat(job)}
                      >
                        <Headphones size={16}/>
                      </button>
                    )} */}
                  </div>
                </div>

                {/* ── Meta ── */}
                <div className="aj-card__meta">
                  <span><MapPin size={13}/> {job.location}</span>
                  <span><Calendar size={13}/> {job.date}</span>
                  <span><User size={13}/> {job.customer}</span>
                </div>

                <div className="aj-card__bid-row">
                  <span className="aj-card__bid-label">Job Price:</span>
                  <span className="aj-card__bid-val">Rs {job.price}</span>
                </div>

                {job.note ? <p className="aj-card__note">📝 {job.note}</p> : null}

                {/* Customer media */}
                {job.customerMedia && job.customerMedia.length > 0 && (
                  <div className="aj-media-row">
                    <span className="aj-media-label"><ImgIcon size={13}/> Customer's Media:</span>
                    <div className="aj-media-thumbs">
                      {job.customerMedia.map((m, mi) => (
                        <button key={mi} className="aj-media-thumb" onClick={() => setLightbox(m)}>
                          {m.type === 'video'
                            ? <><img src={m.thumb || m.url} className="aj-media-thumb__img" alt=""/><div className="aj-media-thumb__play"><Play size={14} fill="#fff" color="#fff"/></div></>
                            : <img src={m.url} className="aj-media-thumb__img" alt=""/>}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Proof media */}
                {job.proofMedia && job.proofMedia.length > 0 && (
                  <div className="aj-media-row">
                    <span className="aj-media-label" style={{ color:'#10b981' }}><ImgIcon size={13}/> My Proof:</span>
                    <div className="aj-media-thumbs">
                      {job.proofMedia.map((m, mi) => (
                        <button key={mi} className="aj-media-thumb" onClick={() => setLightbox(m)}>
                          {m.type === 'video'
                            ? <><video src={m.url} className="aj-media-thumb__img"/><div className="aj-media-thumb__play"><Play size={12} fill="#fff" color="#fff"/></div></>
                            : <img src={m.url} className="aj-media-thumb__img" alt=""/>}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Review */}
                {job.review && (
                  <div className="aj-review">
                    <div className="aj-review__header">
                      <User size={14}/><span>{job.customer}</span><Stars rating={job.review.rating}/>
                    </div>
                    <p className="aj-review__text">{job.review.text}</p>
                    {job.workerReply ? (
                      <div className="aj-review__reply"><MessageSquare size={13}/> <span>Your reply:</span> {job.workerReply}</div>
                    ) : (
                      <div className="aj-review__reply-form">
                        <input
                          type="text"
                          placeholder="Write a reply..."
                          value={replies[job.id] || ''}
                          onChange={e => setReplies(r => ({ ...r, [job.id]: e.target.value }))}
                          onKeyDown={e => e.key === 'Enter' && handleReply(job.id)}
                          className="aj-review__reply-input"
                        />
                        <button className="aj-review__reply-btn" onClick={() => handleReply(job.id)}><Send size={14}/></button>
                      </div>
                    )}
                  </div>
                )}

                {/* ── Actions ── */}
                <div className="aj-card__actions">

                  {/* open */}
                  {job.state === 'open' && (
                    <>
                      <button className="aj-btn aj-btn--accept" onClick={() => handleAccept(job.id)}>
                        <CheckCircle size={14}/> Accept
                      </button>
                      <button className="aj-btn aj-btn--reject" onClick={() => handleReject(job.id)}>
                        <XCircle size={14}/> Reject
                      </button>
                    </>
                  )}

                  {/* assigned */}
                  {job.state === 'assigned' && (
                    <>
                      <button className="aj-btn aj-btn--progress" onClick={() => handleStart(job.id)}>
                        <AlertCircle size={14}/> Start Job
                      </button>
                      <button className="aj-btn aj-btn--reject" onClick={() => handleReject(job.id)}>
                        <XCircle size={14}/> Cancel
                      </button>
                    </>
                  )}

                  {/* in_progress:
                      - "Upload Proof & Complete" → proof modal
                      - "Raise Dispute" → state:worker_dispute + redirect to support (new ticket)   */}
                  {job.state === 'in_progress' && (
                    <>
                      <button className="aj-btn aj-btn--complete" onClick={() => setProofFor(job.id)}>
                        <Upload size={14}/> Upload Proof &amp; Complete
                      </button>
                      <button className="aj-btn aj-btn--dispute" onClick={() => handleRaiseDispute(job)}>
                        <ShieldAlert size={14}/> Raise Dispute
                      </button>
                    </>
                  )}

                  {/* awaiting_confirmation */}
                  {job.state === 'awaiting_confirmation' && (
                    <div className="aj-card__awaiting">
                      ⏳ Proof submitted — Waiting for customer confirmation (auto-release in 24h)
                    </div>
                  )}

                  {/* worker_dispute — info only; action via headphones button in top-right */}
                {job.state === 'worker_dispute' && (
  <div className="aj-dispute-row">
    <div className="aj-card__dispute" style={{ color:'#f97316', background:'rgba(249,115,22,0.09)', flex:1 }}>
      🛡️ Dispute submitted — open chat to talk with Admin.
    </div>
    <button className="aj-btn-dispute-chat"    onClick={() => navigate(`/chat`)}>
      <Headphones size={15}/> Chat
    </button>
  </div>
)}

                  {job.state === 'completed'      && <div className="aj-card__done">✅ Job completed — payment released!</div>}
                  {job.state === 'cancelled'      && <div className="aj-card__rejected">❌ Job cancelled</div>}
                  {job.state === 'refunded'       && <div className="aj-card__rejected">💸 Refunded to customer</div>}
                  {job.state === 'dispute_frozen' && <div className="aj-card__dispute">🔒 Under admin review — all actions paused</div>}
                  {job.state === 'admin_review'   && <div className="aj-card__dispute">⚠️ Escalated for manual decision</div>}

                </div>
              </div>
            );
          })}
        </div>
      </div>

      {proofFor && (
        <ProofModal
          onClose={() => setProofFor(null)}
          onSubmit={files => handleProof(proofFor, files)}
        />
      )}
      <Lightbox item={lightbox} onClose={() => setLightbox(null)}/>
    </>
  );
};

export default AllJobs;